var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card',{staticClass:"elevation-2"},[_c('CurrentlyPlaying',{attrs:{"deviceType":"playstations"}})],1),_c('v-card',{staticClass:"elevation-2 mt-8"},[_c('CurrentlyPlaying',{attrs:{"deviceType":"computers"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }